import React, { useState } from "react";

import "../styles/sass/main.scss";
import DropDown from "./dropdown";
import Burger from "./burger";
import SideMenu from "./sidemenu";
import logo from "../images/logo.png";

const Header = () => {

  const [open, setOpen] = useState(false);

  return (
    <header>
      <title>NeoVative Inc.</title>
      <nav className="nav">
        <div className="nav nav-left">
          <img src={logo} alt="Logo" className="nav-logo"/>
        </div>
        <div className="nav nav-right">
          <div className="nav-item">
            <a href="/">Home</a>
          </div>
          <DropDown title={"Products"} contents={["BlueBox", "Asthmagram"]} />
          <DropDown
            title={"Professional"}
            contents={["CPR", "International consensus on (ICON) pediatric asthma", "Guidelines for the Diagnosis and Management of Asthma (EPR-3)", "2020 AHA Guidelines for CPR"]}
          />
          <DropDown title={"Resource"} contents={["AHA", "AAAAI", "NIH"]} />
          <div className="nav-item">
            <a href="/news">News</a>
          </div>
          <div className="nav-item">
            <a href="/about-us">About Us</a>
          </div>
          <div className="nav-item">
            <a href="/contact-us">Contact Us</a>
          </div>
        </div>
        <div className="nav nav-right nav-stack">
          <Burger open={open} setOpen={setOpen} />
        </div>
      </nav>
      <SideMenu open={open} setOpen={setOpen} />
    </header>
  );
};

export default Header;
